angular.module('GlobalHelpersModule').filter "shortDateUTC", ->
  (date) ->
    if date? and date.toString().length > 0
      moment.utc(date).format('MMM D, YYYY')
    else
      ""
